const MAX_POINTS_ARCHIVE = 3600;
const MAX_POINTS_REALTIME = 180;


class Request {

    constructor() {
        this.id = null; // request id (command sequence in connection)
        this.command = null; // command name
        this.data = null; // data
    }
}


class Response {

    static get OK() {
        return 200;
    }

    static get ERROR() {
        return 400; // BAD REQUEST
    }

    static get UNAUTHORIZED() {
        return 403;
    }

    constructor() {
        this.cid = null; // Connection id, -1 if used for subscription response (broadcasting)
        this.id = null; // Command id (command sequence in connection)
        this.code = null; // return code (from http codes)
        this.data = null; // return data
    }
}
















// ===================================================================================================
//
//
// ===================================================================================================
















// ws client for telegram_bot ws_server - acquire pulse graphs
class WsClient {

    constructor(address, dynamicGraph) {

        //websocket client
        this.ws = null;

        this._initWs = this._initWs.bind(this);

        this.adress = address;



        // counter of client requests (request id)
        this.rid = 0;

        //handlers for requests
        this.callbacks = {};

        // assign rendering callbacks
        this.graphLoadGraphs = dynamicGraph.graphLoadGraphs;
        this.graphUpdateGraphs = dynamicGraph.graphUpdateGraphs;

        // DEBUG - DISABLED UNTIL DEBUGGING DATABASE HAS FINISHED
        //this._initWs();
    }




    _initWs() {
        //telegram_bot where websocket is running is not still on cluster - its on 31.210.208.161:8070 (p1)
        this.ws = new WebSocket(this.adress, 'protocol1');

        this.ws.onopen = function() {

            // console.log('Соединение установлено.');

            // Get previous data
            this.getGraphs('min', MAX_POINTS_ARCHIVE);
            this.getGraphs('sec', MAX_POINTS_REALTIME);

            // receive data updates
            this.subcribeGraphsUpdate();


        }.bind(this);


        this.ws.onclose = function(event) {
            if (event.wasClean) {
                // console.log('Соединение закрыто нормально');
            } else {
                console.log('Обрыв соединения с сервером'); // например, "убит" процесс сервера
                this.ws = null;
                // automatically reconnect
                setTimeout(this._initWs, 3000);
            }
        }.bind(this);


        this.ws.onmessage = function(event) {
            //console.log('Msg: ' + event.data);
            this.processResponse(event.data);
        }.bind(this);


        this.ws.onerror = function(error) {
            console.log('Error: ' + error.message);
        }.bind(this);

    }



    /*
        //CONNECTING OPEN CLOSING or CLOSED
        if(this.ws.readyState === this.ws.OPEN){
           // Do your stuff...
        }
    */

    // ------------------------------------------------------------------------------


    close() {
        this.ws.close();
    }


    /// Request server for RPC
    /// command - имя команды
    /// data - параметры команды
    /// handler - callback для обработки результат запроса - ответа с сервера
    performRequest(command, data, handler) {

        let request = new Request();
        request.command = command;
        request.data = data;
        request.id = this.rid++;
        this.callbacks[request.id] = handler;


        if (command === 'subscribe') {
            // не реагируем об ответе на команду "оформить подписку"
            this.callbacks[request.id] = null;
            // вешаем callback на имя функции
            this.callbacks[data] = handler;
        }
        if (command === 'unsubscribe') {
            // не реагируем об ответе на команду "отключить подписку"
            this.callbacks[request.id] = null;
            // удаляем callback
            delete this.callbacks[data];
        }
        this.ws.send(JSON.stringify(request));
    }



    // Process server response
    processResponse(message) {

        // response.code - RPC result
        // response.id   - callback id in callbacks[] to handle this response
        //                 may be longint (for regular requests) and string (for subscription)
        // response.data - response data
        let response = JSON.parse(message);

        //console.log(response);

        // Only handle response if server say OK (not error) and callback assigned
        if (response.code === Response.OK && this.callbacks[response.id] !== null) {

            this.callbacks[response.id](response.data);

        } else if (response.code === Response.ERROR) {
            console.log('Сервер - неверный запрос: ' + response.id);
        }

        //убираем обработчик запроса, если это не обработчик подписки
        if (response.cid !== -1) {
            delete this.callbacks[response.id];
        }

    }


    // ------------------------------------------------------------------------------


    getGraphs(type, count) {
        let data = {};
        data.type = type;
        data.count = count;
        this.performRequest('get_graphs_data', data, this.graphLoadGraphs);
    }


    subcribeGraphsUpdate() {
        this.performRequest('subscribe', 'graphs_update', this.graphUpdateGraphs);
    }
}


// ----------------------------------------------------------------------------------------















// ===================================================================================================
//
//
// ===================================================================================================
















class DynamicGraph {


    constructor(id_archive, id_realtime) {

        this.graphLoadGraphs = this.graphLoadGraphs.bind(this);
        this.graphUpdateGraphs = this.graphUpdateGraphs.bind(this);



        this.chartList = {};

        let chart = new CanvasJS.Chart(id_archive, {
            zoomEnabled: true,
            theme: "light2",
            width: 630,
            height: 280,
            backgroundColor: "rgb(184, 200, 209)",
            title: {
                text: "Archive",
                fontSize: 14
            },

            axisX: {
                labelFontSize: 12,
                labelAutoFit: false,
                valueFormatString: "HH:mm",
                crosshair: {
                    enabled: true,
                    snapToDataPoint: true
                },
                gridColor: "lightblue",
                gridThickness: 1
            },

            axisY: {
                //title: "Clients",
                labelFontSize: 12,
                labelAutoFit: false,
                crosshair: {
                    enabled: true,
                    snapToDataPoint: true
                },
                gridColor: "lightblue",
                gridThickness: 1
            },

            toolTip: {
                fontSize: 14,
            },

            legend: {
                fontSize: 14,
                cursor: "pointer",
                verticalAlign: "bottom",
                horizontalAlign: "left",
                dockInsidePlotArea: true,
                itemclick: function(e) {
                    if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
                        e.dataSeries.visible = false;
                    } else {
                        e.dataSeries.visible = true;
                    }
                    e.chart.render();
                }
            },

            data: []

        });
        chart.name = 'min';
        this.chartList[chart.name] = chart;

        //
        //

        chart = new CanvasJS.Chart(id_realtime, {
            theme: "light2",
            width: 630,
            height: 280,
            backgroundColor: "rgb(184, 200, 209)",
            title: {
                text: "Realtime",
                fontSize: 14
            },

            axisX: {
                labelFontSize: 12,
                labelAutoFit: false,
                //labelAngle: 40,
                valueFormatString: "HH:mm:ss",

                crosshair: {
                    enabled: true,
                    snapToDataPoint: true
                },
                gridColor: "lightblue",
                gridThickness: 1
            },

            axisY: {
                //title: "Clients",
                labelFontSize: 12,
                labelAutoFit: false,
                crosshair: {
                    enabled: true,
                    snapToDataPoint: true
                },
                gridColor: "lightblue",
                gridThickness: 1
            },

            toolTip: {
                fontSize: 14,
            },

            legend: {
                fontSize: 14,
                cursor: "pointer",
                verticalAlign: "bottom",
                horizontalAlign: "left",
                dockInsidePlotArea: true,
                itemclick: function(e) {
                    if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
                        e.dataSeries.visible = false;
                    } else {
                        e.dataSeries.visible = true;
                    }
                    e.chart.render();
                }
            },

            data: []
        });
        chart.name = 'sec';
        this.chartList[chart.name] = chart;
    }



    // ----------------------------------------------------------------------------------------

    close() {
        for (let item in this.chartList) {
            if (this.chartList.hasOwnProperty(item)) {
                this.chartList[item].destroy();
            }
        }
    }


    graphLoadGraphs(data) {

        let streamerList = data.streamerList;
        let dataIndex = 0;

        this.chartList[data.type].options.data = [];


        let t = new Date(data.time);
        let koeff = 1;
        if (data.type === 'min') {
            koeff = 60;
        }

        for (let name in streamerList) {
            if (streamerList.hasOwnProperty(name)) {
                if ((name === 'T1') || (name === 'T4')) {
                    continue;
                }


                this.chartList[data.type].options.data[dataIndex] = {
                    //type: "spline",
                    type: "line",
                    markerType: "none",
                    markerSize: 5,
                    showInLegend: true,
                    toolTipContent: "{label}<br/>{name}, <strong>{y}</strong>: {x}",
                    name: name,
                    xValueFormatString: "HH:mm:ss",
                    dataPoints: []
                };

                let points = data.streamerList[name].graphs.clients;

                for (let i = 0; i < points.length; i++) {

                    let x = new Date(t - (points.length - 1 - i) * 1000 * koeff);
                    let y = points[i];
                    let point = { x: x, y: y };

                    this.chartList[data.type].options.data[dataIndex].dataPoints.push(point);
                }

                // inc index
                dataIndex++;
            }
            this.chartList[data.type].render();
        }
    }



    // ----------------------------------------------------------------------------------------



    graphUpdateGraphs(data) {
        let streamerList = data.streamerList;
        let dataIndex = 0; // Номер стримера в массиве графиков canvasJS

        let t = new Date(data.time);

        let maxCount;
        if (data.type === 'min') {
            maxCount = MAX_POINTS_ARCHIVE;
        } else if (data.type === 'sec') {
            maxCount = MAX_POINTS_REALTIME;
        }

        for (let name in streamerList) {
            if (streamerList.hasOwnProperty(name)) {

                if ((name === 'T1') || (name === 'T4')) {
                    continue;
                }


                let points = data.streamerList[name].graphs.clients;

                let point = { x: t, y: points[0] };

                this.chartList[data.type].options.data[dataIndex].dataPoints.push(point);


                if (this.chartList[data.type].options.data[dataIndex].dataPoints.length > maxCount) {
                    this.chartList[data.type].options.data[dataIndex].dataPoints.splice(0, 1);
                }

                // inc index
                dataIndex++;
            }
            this.chartList[data.type].render();
        }
    }

} // class DynamicGraph







// ===================================================================================================
//
//
// ===================================================================================================





class PulseGraph {

    constructor(id_archive, id_realtime, address) {
        //this.repaint = this.repaint.bind(this);
        this.graph = new DynamicGraph(id_archive, id_realtime);
        this.wsclient = new WsClient(address, this.graph);
    }

    close() {
        this.wsclient.close();
        this.graph.close();
        this.wsclient = null;
        this.graph = null
    }

    repaint() {
        for (let item in this.graph.chartList) {
            //if (this.chartList.hasOwnProperty(item)) {
            this.graph.chartList[item].render();
            //}
        }
    }



}

export default PulseGraph


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// Usage:
/*
let pg = new PulseGraph("chartContainer_archive",
                        "chartContainer_realtime",
                        "wss://p0.tv.kvant-telecom.ru:8070");
*/



// WEBPACK FOOTER //
// ./src/script/pulse_graph.js